// extracted by mini-css-extract-plugin
export default {"disposalRegistrarCommandPanel":"DisposalRegistrar_disposalRegistrarCommandPanel__DnzHS"};